import Vehicles from './manufacturer-vehicles.component'

export default Vehicles
